// ------------------------------------------------------------------
// Datas "sem hora" (nascimento, data referência, datas de situação).
//
// Problema que isto resolve: o `DateInput` do react-admin envia apenas
// "YYYY-MM-DD". A API grava isso como meia-noite, e o navegador (UTC-3)
// ao reexibir recuava um dia — 20/05 virava 19/05, e cada novo salvamento
// recuava mais um dia.
//
// Solução: gravar sempre ao MEIO-DIA em UTC e ler/exibir em UTC. Com 12h
// de folga para cada lado, nenhum fuso horário do mundo cruza a virada do
// dia, e os registros antigos (gravados a 00:00Z) voltam a aparecer certos.
// ------------------------------------------------------------------

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Extrai o "YYYY-MM-DD" de um valor vindo da API, sempre em UTC. */
export const toDateOnly = (value: any): string => {
  if (!value) return "";
  if (typeof value === "string" && ISO_DATE.test(value)) return value;

  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toISOString().slice(0, 10);
};

/** `format` do DateInput: preenche o campo com a data correta (UTC). */
export const formatDateOnly = (value: any) => toDateOnly(value);

/** `parse` do DateInput: envia meio-dia UTC, imune a fuso horário. */
export const parseDateOnly = (value: any) => {
  if (!value) return null;

  const dateOnly = toDateOnly(value);
  if (!dateOnly) return null;

  return `${dateOnly}T12:00:00.000Z`;
};

/** Exibição em pt-BR (dd/mm/aaaa) sem deslocamento de fuso. */
export const displayDateOnly = (value: any): string => {
  const dateOnly = toDateOnly(value);
  if (!dateOnly) return "";

  const [year, month, day] = dateOnly.split("-");
  return `${day}/${month}/${year}`;
};

/** Props prontas para usar em `<DateInput {...dateOnlyProps} />`. */
export const dateOnlyProps = {
  format: formatDateOnly,
  parse: parseDateOnly,
};
